<!-- 课程分类 -->

<template>
  <div class="main" v-loading="loading">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" placeholder="搜索分类名称" suffix-icon="el-icon-search" v-model="categoryName"
        :clearable="true" @change="onSearch"></el-input>
      <el-button class="btn" type="primary" @click="handleAddOne">新增分类</el-button>
    </div>

    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" row-key="id">
        <el-table-column show-overflow-tooltip min-width="120" prop="categoryName" label="分类名称"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="sortNum" label="排序"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button class="btn" type="primary" plain @click="handleEdit(scope.row)">修改</el-button>
            <el-button class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <!-- 分类弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="demo-ruleForm" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="类目名称" prop="categoryOne">
              <el-input v-model="ruleForm.categoryOne" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="red">
            <el-form-item label="类目排序" prop="sortOne">
              <el-input v-model="ruleForm.sortOne" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      categoryName: "", // 搜索分类
      // 表格数据
      tableData: [],
      // 弹窗
      dialogVisible: false,
      dialogTitle: "",
      isCategoryOneAdd: false, // 一级分类新增
      isCategoryOneEdit: false, // 一级分类编辑
      ruleForm: {
        categoryOne: "",
        sortOne: "",
        id: "",
      },
      rules: {
        categoryOne: [{
          required: true,
          message: "请输入类目名称",
          trigger: "blur",
        },],
        sortOne: [{
          required: true,
          message: "请输入类目排序",
          trigger: "blur",
        },
        {
          validator: function (rule, value, callback) {
            if (/^[1-9]\d*$/.test(value) == false) {
              callback(new Error("请输入整数"))
            } else {
              //校验通过
              callback()
            }
          },
          trigger: "blur",
        },
        ],
      },
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getLiveCategoryList()
  },
  methods: {
    // 列表
    getLiveCategoryList() {
      this.loading = true
      this.$axios
        .get(this.$api.getLiveCategoryListPage, {
          params: {
            categoryName: this.categoryName || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list || []
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 新增一级分类
    handleAddOne() {
      this.dialogTitle = "新增分类"
      this.dialogVisible = true
      this.isCategoryOneAdd = true
    },
    // 修改
    handleEdit(row) {
      this.dialogVisible = true
      this.dialogTitle = "修改分类"
      this.isCategoryOneEdit = true
      this.$set(this.ruleForm, "categoryOne", row.categoryName)
      this.$set(this.ruleForm, "sortOne", row.sortNum)
      this.$set(this.ruleForm, "id", row.id)
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false
      this.dialogTitle = ""
      this.resetForm()
      this.ruleForm = {}
      this.isCategoryOneAdd = false
      this.isCategoryOneEdit = false
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          console.log("error submit!!")
          return false
        } else {
          // 请求方式
          let requestMethod
          // api
          let apiUrl
          if (this.isCategoryOneAdd) {
            apiUrl = this.$api.newAddLiveCategory
            requestMethod = "post"
          } else if (this.isCategoryOneEdit) {
            apiUrl = this.$api.newUpdateLiveCategory
            requestMethod = "post"
          }
          // 传参
          let data
          if (this.isCategoryOneAdd) {
            data = {
              categoryName: this.ruleForm.categoryOne,
              sortNum: this.ruleForm.sortOne,
            }
          } else if (this.isCategoryOneEdit) {
            data = {
              categoryName: this.ruleForm.categoryOne,
              sortNum: this.ruleForm.sortOne,
              id: this.ruleForm.id,
            }
          }
          this.$axios[requestMethod](apiUrl, data)
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.getLiveCategoryList()
                this.handleCloseDialog()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        }
      })
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.newDeleteLiveCategory, {
              id: row.id
            })
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.getLiveCategoryList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    // 默认弹窗设置重置表单
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.getLiveCategoryList()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.getLiveCategoryList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getLiveCategoryList()
    },
  },
}
</script>

<style lang="scss" scoped>
.main {

  .red {
    ::v-deep .el-form-item__label {
      color: #FE3A09;
    }
  }
}
</style>
